import { motion } from 'framer-motion';
import CountUpAnimation from './CountUpAnimation';

const LiveTrackingStatCard = ({ stat, idx }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: idx * 0.1 }}
      className="bg-white/10 backdrop-blur-md rounded-2xl p-3.5 sm:p-5 md:p-6 flex flex-col items-center justify-between text-center w-[calc(50%-8px)] min-w-[130px] sm:w-[160px] md:w-[180px] lg:w-[190px] h-[190px] sm:h-[210px] md:h-[220px] shadow-[0_8px_32px_0_rgba(0,0,0,0.15)] hover:shadow-[0_8px_32px_0_rgba(6,121,120,0.25)] hover:-translate-y-1 transition-all duration-300 border border-white/20"
    >
      <div className="space-y-1 w-full">
        <h3 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white tracking-tight">
          <CountUpAnimation target={stat.count} suffix={stat.suffix} />
        </h3>
        <p className="text-white/85 font-bold text-[11px] sm:text-xs md:text-sm leading-tight">
          {stat.label}
        </p>
      </div>

      <div className="w-[56px] h-[56px] sm:w-[75px] sm:h-[75px] md:w-[90px] md:h-[90px] flex items-center justify-center mt-auto">
        <img
          src={stat.icon}
          alt={stat.label}
          className="w-full h-full object-contain filter drop-shadow-md brightness-200"
        />
      </div>
    </motion.div>
  );
};

export default LiveTrackingStatCard;
